import {
	OverdistributionErrorSourceEnum,
	ValuationSummaryGroupByPersonRes,
} from '@dealstack/shared/lib/generated';
import {
	personGroupHasErrors,
	ValuationsValidationError,
} from '@dealstack/frontend/app/pages/Valuations/components/ValuationsWarnings/ValuationsWarnings.utils';

const errorLocaleMap: Record<string, { title: string; description: string }> = {
	[OverdistributionErrorSourceEnum.SOURCES]: {
		title: 'valuations_error.overdistribution_sources_error_title',
		description: 'valuations_error.overdistribution_sources_error_description',
	},
	[OverdistributionErrorSourceEnum.USES]: {
		title: 'valuations_error.overdistribution_uses_error_title',
		description: 'valuations_error.overdistribution_uses_error_description',
	},
	[OverdistributionErrorSourceEnum.OVERRIDES]: {
		title: 'valuations_error.overdistribution_overrides_error_title',
		description: 'valuations_error.overdistribution_overrides_error_description',
	},
};

const defaultErrorLocale = {
	title: 'valuations_error.unknown_error_title',
	description: 'valuations_error.unknown_error_description',
};

export function computeValidationErrors(
	summaryByPerson: ValuationSummaryGroupByPersonRes | undefined
): ValuationsValidationError[] {
	if (!summaryByPerson) {
		return [];
	}
	return summaryByPerson.persons.flatMap((person) =>
		person.groups.filter(personGroupHasErrors).map((group) => {
			const { title, description } =
				errorLocaleMap[group.error.source.component] ?? defaultErrorLocale;

			return {
				personId: person.id,
				mipId: group.id,
				sourceType: group.error.source.component,
				overrideTier: group.error.source.tier,
				title,
				description,
			};
		})
	);
}
